import { EventEmitter } from "events";
export class AudioComponent extends EventEmitter {
    constructor(name) {
        super();
        this.debug = false;
        this._name = name;
    }
    get name() {
        return this._name;
    }
    log(...args) {
        if (this.debug) {
            console.log(...args);
        }
    }
}
